import { RuleCheckStateWithoutModules } from './types';

export default function initialState(): RuleCheckStateWithoutModules {
  return {
    showRuleViolationModalForActivity: null,
  };
}
